import '../../js/_core/tablesort/src/tablesort.js';
import * as Helper from './helpers.mjs';
import {Modal} from './modal.mjs';

class Index {
    constructor($container, config = "", name = "index") {
        this.container = $container;
        this.section = Helper.getPageInfo("section");
        this.action = Helper.getPageInfo("action");
        // Form name
        this.name = name;

        this.config = $.extend({}, {
            addRoute: false,
            editRoute: false,
            deleteRoute: false,
            copyRoute: false,
            giftRoute: false,
            suspendRoute: false,
            activateRoute: false,
            maxNames: 5,
            jsPagination: true
		}, config);

        this.entityActions = this.config.actions;

        for (var entityAction in this.entityActions) {
            this.entityActions[entityAction].setIndex(this);
        }
        
        if (Cookies.get('weaveId')) {
            this.currentWeave = Cookies.get('weaveId');
        }

        this.isDirty = false;

        //TODO: Convert to vanilla JS
        $('.form-filter .form-select, .form-filter .form-input, .form-filter .form-checkbox').change(this.onFilter.bind(this));
        // $('.form-filter .form-select').keypress(this.onKeyPress.bind(this));

        var useSelect = document.querySelectorAll(".form-select.use-selectr");
        if (useSelect.length > 0) {
            useSelect.forEach(s => {
                var sel = new Selectr(s);
            });
        }

        // $('#index_search').keyup($.proxy(this.liveSearch, this));
        // $('#index_search').change($.proxy(this.liveSearch, this));

        // this.container.on('click', '#pageNav span:not(.disabled)', $.proxy(this.onClickPageButton, this));

        //this.container.on('click', 'tbody > tr', $.proxy(this.editAction, this));

        // we shouldn't be doing this really - need to look into it
        /* $(window).keydown(function(event) {
            if (event.keyCode == 13) {
                event.preventDefault();
                return false;
            }
        }); */

        Helper.PubSub.sub('reloadTable', this.loadList.bind(this));

        this.loadList();
    }

    beforeSort() {
        this.container.find('tbody tr').each(function(){
            this.style.display = "table-row";
        });
    }

    //TODO: add code to show spinner between page changes

    getOffset() {
        return this.page > 1 ? this.limit * (this.page - 1) : 0;
    }

    getPageFrom() {
        return this.getOffset() + 1;
    }

    getPageTo() {
        var offset = this.getOffset();
        return (offset + this.limit) > this.totalResults ? this.totalResults : offset * 1 + this.limit * 1;
    }

    onFilter(e) {
        if (e.target.id === 'filterByLimit' && this.config.jsPagination) {
            this.limit = e.target.value;
            this.totalPages = Math.ceil(this.totalResults / this.limit);
            this.filterByLimit();
            var details = document.querySelectorAll('.page-details-pages');
            details.forEach(d=>{
                d.innerText = `Page ${this.page} of ${this.totalPages}`;
            });
            details = document.querySelector('.page-details-results');
            if (details) {
                details.innerText = "Showing results " + this.getPageFrom() + " to " + this.getPageTo();
            }
            this.reflowPages();
            // var pagination = document.querySelectorAll('.pagination .page-numbers');
            // pagination.forEach((p)=>{ this.repaginate(p); });
        } else {
            this.loadList();
        }
    }

    filterByLimit() {
        var formElement = document.querySelector('[name="' + this.name + '"]');
        var formAction = formElement.attributes.action.value;
        if (formAction.includes("stock-searches")) { // ONLY WORKS FOR STOCK SEARCHES PAGE?
            var start = ((this.page - 1) * this.limit) + 1;
            var i = (start ?? 0);
        } else { // WORK FOR OTHER PAGES CONTAINING PAGINATION?
            var i = 0;
            var start = (this.page - 1) * this.limit;
        }
        var end = start + this.limit * 1;
        
        this.container.find('table').first().find('tbody tr').each(function(){
            if (i < start || i >= end) {
                this.style.display = "none";
            } else {
                this.style.display = "table-row";
            }
            i++;
        });
    }


    //! CREATE ROUTES BASED ON URL PATH


    //? TABLE ACTIONS

    getSelectedRowIds(field, values) {
        if(typeof field === "undefined"){
            field = false;
        }
        if(typeof values === "undefined"){
            values = false;
        }
        let checkboxes = this.container[0].querySelectorAll("[id^=selectRow]:checked");
        let rows = [];

        Array.prototype.forEach.call(checkboxes, (checkbox, index) => {

            let row = checkbox.closest("tr");

            if(field == false || values == false){
                // if (checkbox.checked) {
                    rows.push(row.dataset.id);
                // }
            }

            if(field != false && Array.isArray(values)){
                values.forEach(function (value, index) {
                    if(row.getAttribute("data-" + field) == value){
                        rows.push(row.dataset.id);
                    }
                })
            }
        });

        return rows;
    }

    getSelectedRowNames(rowIds) {

        if(typeof rowIds == "undefined"){
            return false;
        }
        let itemType = Helper.getPageInfo("section");
        var _this = this;
        let names = [];
        rowIds.forEach(function(id, index){
            if (index >= _this.config.maxNames) return;
            let row = _this.container[0].querySelector("tr[data-id='" + id + "']");
            if (row.dataset.name) {
                names.push(row.dataset.name);
            } else {
                names.push(itemType + " (" + id  + ")");
            }            
        });

        var string = names.join(', ');
        if (rowIds.length > _this.config.maxNames) {
            string += ' and ' + (rowIds.length - _this.config.maxNames) + ' others';
        }
        return string;
    }

    importRowsAction(e) {
        var modalId;
        if(e.target.nodeName !== "BUTTON"){
            modalId = $(e.target).closest('.btn').attr('data-modal-open');
        } else{
            modalId = e.target.dataset.modalOpen;
        }
        var modal = $("#" + modalId);
        modal.addClass("active");
        var formInput = modal.find("#importFileForm");
        var _this = this;
        formInput.on('change', _this.confirmImportRows(e, modal)); 
    }

    confirmImportRows(e, modal){
        modal.find("[data-action=confirm]").removeAttr("disabled");
        modal.find(".modal-footer menu").off("click").on("click", ".btn", (e) => {
            if($(e.target).closest('.btn').attr('data-action') == "confirm"){
                modal.removeClass("active");
                this.importRows();            
            }
        });         
    
    }

    importRows() {
        var importUrl = this.config.importRoute;

        $.ajax({
            url: importUrl,
            type: "post",
        }).done(function() {
           this.importRowsCallback(true);
        })
        .fail(function() {
            this.importRowsCallback(false);
        });
    }

    importRowsCallback(isSuccess) {

        if(isSuccess){
            Helper.notify('Items Imported');
            this.loadList();
        } else{
            Helper.notify('Imported failed, please try again');     
        }

    }

    addAction(e) {
        var url = $(e.target).attr("href");

        if (url) {
            if (e.shiftKey === true) {
                window.open(url, '');
            } else if (e.ctrlKey === true) {
                window.open(url, '_blank');
            } else {
                location.href = url;
            }
            return;
        }

        var modalId;
        if(e.target.nodeName !== "BUTTON"){
            modalId = $(e.target).closest('.btn').attr('data-modal-open');
        } else{
            modalId = e.target.dataset.modalOpen;
        }
        var modal = $("#" + modalId);
        modal.addClass("active");
    }

    addEntity() {
        fetch (this.config.addRoute);
    }

    //? ROW ACTIONS

    //? edit


    editAction(e) {
        if (this.config.editRoute === false) {
            return;
        }

        // get rowId
        var id = $(e.target).parents("tr").attr('data-id');

        var url = $(e.target).attr("href") + '/' + id;
        if (!$(e.target).attr("href")) {
            url = this.config.editRoute + '/' + id;
        }

        if (e.shiftKey === true) {
            window.open(url, '');
        } else if (e.ctrlKey === true) {
            window.open(url, '_blank');
        } else {
            location.href = url;
        }
    }

    //? delete

    getEntityName(e) {
        return $(e.target).closest('tr').find("td:nth-of-type(2)").text();
    }

    /* deleteAction(e) {
        if (this.config.deleteRoute === false) {
            return false;
        }
        
        var row = $(e.target).closest('tr')[0];
        var id = row.getAttribute("data-id");

        var name = this.getEntityName(e);
        var modalId;

        if (e.target.nodeName !== "BUTTON"){
            modalId = $(e.target).closest('button').attr('data-modal-open');
        } else {
            modalId = e.target.dataset.modalOpen;
        }

        this.confirmDeleteEntity(id, modalId, name);

        //return false;
    } */

    /* confirmDeleteEntity(id, modalId, name) {

        //TODO:  Use WeaveModal class to manage message confirmation OR move to Helper class
        var modal = $("#" + modalId);
        modal.find(".modal-header .plural").hide();
        modal.find(".modal-header .singular").show();
        modal.find(".modal-body .items").show().text(name);
        modal.addClass("active");
        modal.find(".modal-footer menu").off("click").on("click", ".btn", (e) => {
            if($(e.target).closest('.btn').attr('data-action') == "confirm"){
                modal.removeClass("active");
                this.deleteEntity(id);            
            }
        });

    }
    
    deleteEntity(id) {
        var deleteUrl = this.config.deleteRoute + '/' + id;
        this.loading('Deleting...');

        return $.ajax({
            url: deleteUrl,
            type: "post",
            dataType: "json"
        }).done($.proxy(this.deleteCallback, this));
    }

    deleteCallback(result) {
        this.stopLoading();
        if (result.success) {
            Helper.notify('Item deleted');
            this.loadList();
            Helper.updateWeaveBadges();
        } else {
            Helper.notify(result.msg);
        }
    } */

    

    //? copy = same as add except details are filled in

    copyAction(e) {
        if (this.config.copyRoute === false) {
            return;
        }

        // get rowId
        var id = $(e.target).parents("tr").attr('data-id');

        var url = $(e.target).attr("href");
        var modalId;
        if(e.target.nodeName !== "BUTTON"){
            modalId = $(e.target).closest('.btn').attr('data-modal-open');
        } else{
            modalId = e.target.dataset.modalOpen;
        }
        
        var name = $(e.target).closest('tr').find("td:nth-of-type(2)").text();
        this.confirmCopyEntity(id, modalId, name);

        return false;
    }

    confirmCopyEntity(id, modalId, name) {
        //TODO:  Use WeaveModal class to manage message confirmation OR move to Helper class
        var modal = $("#" + modalId);
        modal.find(".modal-header .plural").hide();
        modal.find(".modal-body .items").show().text(name);
        modal.addClass("active");
        modal.find(".modal-footer menu").off("click").on("click", ".btn", (e) => {
            if($(e.target).closest('.btn').attr('data-action') == "confirm"){
                modal.removeClass("active");
                this.copyEntity(id);            
            }
        });
    }
    
    copyEntity(id, e) {
        var copyRoute = this.config.copyRoute + '/' + id;

        // return $.ajax({
        //     url: copyRoute,
        //     type: "post",
        //     dataType: "json"
        // }).done($.proxy(this.copyCallback, this));

        var url = copyRoute;

        if (e.shiftKey === true) {
            window.open(url, '');
        } else if (e.ctrlKey === true) {
            window.open(url, '_blank');
        } else {
            location.href = url;
        }
    }


    copyCallback() {
        Helper.notify('Item copied');
        this.loadList();
    }

    
    //? gift = same as copy(?)

    giftAction(e) {
        if (this.config.giftRoute === false) {
            return;
        }

        // get rowId
        var id = $(e.target).parents("tr").attr('data-id');

        var url = $(e.target).attr("href");
        var modalId;
        if(e.target.nodeName !== "BUTTON"){
            modalId = $(e.target).closest('.btn').attr('data-modal-open');
        } else{
            modalId = e.target.dataset.modalOpen;
        }
        
        var name = $(e.target).closest('tr').find("td:nth-of-type(2)").text();
        this.confirmGiftEntity(id, modalId, name);

        return false;
    }

    confirmGiftEntity(id, modalId, name) {
        //TODO:  Use WeaveModal class to manage message confirmation OR move to Helper class
        var modal = $("#" + modalId);
        modal.find(".modal-header .plural").hide();
        modal.find(".modal-body .items").show().text(name);
        modal.addClass("active");
        modal.find(".modal-footer menu").off("click").on("click", ".btn", (e) => {
            if($(e.target).closest('.btn').attr('data-action') == "confirm"){
                modal.removeClass("active");
                this.giftEntity(id);
            }
        });
    }
    
    giftEntity(id, e) {
        var giftRoute = this.config.giftRoute + '/' + id;

        // return $.ajax({
        //     url: giftRoute,
        //     type: "post",
        //     dataType: "json"
        // }).done($.proxy(this.giftCallback, this));

        var url = giftRoute;

        if (e.shiftKey === true) {
            window.open(url, '');
        } else if (e.ctrlKey === true) {
            window.open(url, '_blank');
        } else {
            location.href = url;
        }
    }
    
    giftCallback() {
        Helper.notify('Basket sent to email');
        this.loadList();
    }

    setListHtml(html, pagination=true) {
        this.container.html(html);
        if(this.hasPagination() && pagination){
            this.initPagination();
        }
        this.init();
        this.sortTables();
    }

    sortTables(){
        var tables = this.container.find('table[data-table-sort]');
        var _this = this;
        if(tables != null && window.Tablesort){
            Array.prototype.forEach.call(tables, function(table, index){
                _this.tablesort = window.Tablesort(table);
            });
        }
    }

    toggleAllCheckboxes(event){
        let _event = event.target.checked;
        
        let tableCheckboxes = this.container.find("[id^=selectRow]");
        Array.prototype.forEach.call(tableCheckboxes , function(checkbox, index){
            if (_event) {
                checkbox.checked = true;
            } else {
                checkbox.checked = false;
            }
        });
    }

    hasPagination(){
        var result = true;
        
        if(!document.querySelector("input#indexPage")){
            result = false;
        }
        if(!document.getElementById('indexResults')){
            result = false;
        }
        if(!document.getElementById('indexPages')){
            result = false;
        }
        return result;
    }

    initPagination() {
        
        this.page = (document.getElementById('indexPage')).value * 1;
        this.totalResults = (document.getElementById('indexResults')).value * 1;
        var paginationBtns = this.container.find('.page-item');
        Array.prototype.forEach.call(paginationBtns, (button, index) =>{
            if (this.config.jsPagination) {
                button.addEventListener('click', this.updatePagination.bind(this));
            } else {
                button.addEventListener('click', el => {
                    if (button.dataset.page) {
                        document.getElementById("indexPage").value = button.dataset.page;
                    }
                    this.loadList();
                });
            }
        });
        this.limit = (document.getElementById('filterByLimit')).value * 1;
        if (this.limit && this.config.jsPagination) {
            this.filterByLimit();
        }
        
        this.totalPages = document.getElementById('indexPages').value * 1;
        var $table = this.container.find('table');
        if ($table.length && this.config.jsPagination) {
            $table[0].addEventListener('beforeSort', this.beforeSort.bind(this));
            $table[0].addEventListener('afterSort', this.filterByLimit.bind(this));
        }

        if (this.config.jsPagination) {
            this.reflowPages();
        }
    }

    updatePagination(event) {
        event.preventDefault();
        
        var selectedPageNumber;
        var indexPageField =  document.querySelector('#indexPage');

        if (event.target.nodeName == "A") {
            selectedPageNumber = event.target.dataset.page * 1;
            if (event.target.parentElement.classList.contains("page-prev")) {
                selectedPageNumber = this.page - 1;
            } else if (event.target.parentElement.classList.contains("page-next")) {
                selectedPageNumber = this.page + 1;
            } else if (event.target.parentElement.classList.contains("page-first")) {
                selectedPageNumber = 1;
            } else if (event.target.parentElement.classList.contains("page-last")) {
                selectedPageNumber = this.totalPages;
            }
        }
        if (event.target.nodeName == "LI" || event.target.nodeName == "SPAN") {
            if (event.target.nodeName == "SPAN") {
                selectedPageNumber = event.target.dataset.page * 1;
            } else {
                selectedPageNumber = event.target.firstElementChild.dataset.page * 1;
            }

            if (event.target.classList.contains("page-prev")) {
                selectedPageNumber = this.page - 1;
            } else if (event.target.classList.contains("page-next")) {
                selectedPageNumber = this.page + 1;
            } else if (event.target.classList.contains("page-first")) {
                selectedPageNumber = 1;
            } else if (event.target.classList.contains("page-last")) {
                selectedPageNumber = this.totalPages;
            }
        }

        if (selectedPageNumber > this.totalPages) return;

        if (selectedPageNumber > 0) {
            indexPageField.value = selectedPageNumber;

            this.page = selectedPageNumber * 1;
            this.reflowPages();

            var details = document.querySelectorAll('.page-details-pages');
            details.forEach(d=>{
                d.innerText = `Page ${this.page} of ${this.totalPages}`;
            });

            // RELOAD TABLE IF IN STOCK SEARCHES?
            var formElement = document.querySelector('[name="' + this.name + '"]');
            var formAction = formElement.attributes.action.value;
            if (formAction.includes("stock-searches")) {
                this.loadList();
            }
        }

        if (typeof selectedPageNumber === "undefined") {
            return false;
        }
        // this.loadList();
    }

    reflowPages() {
        var pagination = document.querySelectorAll('.pagination .page-numbers');
        pagination.forEach((p)=>{ this.repaginate(p); });

        this.filterByLimit();
    }

    updatePaginationNav() {
        var selectedPageNumber = this.page;

        if (selectedPageNumber == 1) {
            $(".page-first").addClass("disabled");
            $(".page-prev").addClass("disabled");
            $(".page-last").removeClass("disabled");
            $(".page-next").removeClass("disabled");
        } else if (selectedPageNumber == this.totalPages) {
            $(".page-last").addClass("disabled");
            $(".page-next").addClass("disabled");
            $(".page-first").removeClass("disabled");
            $(".page-prev").removeClass("disabled");
        } else {
            $(".page-first").removeClass("disabled");
            $(".page-prev").removeClass("disabled");
            $(".page-last").removeClass("disabled");
            $(".page-next").removeClass("disabled");
        }
    }

    repaginate(pagination) {
        this.updatePaginationNav();

        pagination.innerHTML = "";
        var showFirst = this.page > 2 ? (this.page > this.totalPages - 3 ? this.totalPages - 4 : this.page - 2) : 1;
        var showLast = this.page > 2 ? (this.page > this.totalPages - 3 ? this.totalPages : this.page + 2) : 5;
        
        if (showFirst < 1) showFirst = 1;
        if (showLast > this.totalPages) showLast = this.totalPages;

        for (var i=showFirst; i<=showLast; i++) {
            var li = document.createElement('li');
            li.classList.add("page-item");
            li.addEventListener('click', this.updatePagination.bind(this));
            if (i == this.page) li.classList.add("active");
            var a = document.createElement('a');
            a.setAttribute('data-page', i);
            a.innerText = i;
            a.href = "#";
            li.appendChild(a);
            pagination.appendChild(li);
        }
    }

// Table checkboxes
    init(){

        if(!window.swiper){
            window.swiper = [];
        }
        
        // TODO: Move to method
        //enable buttons on each row
        var table = this.container.find('table');
        var tableRowButtons = table.find('.row-actions button, .row-actions .btn-link');

        Array.prototype.forEach.call(tableRowButtons, (button, index) =>{

            var btnAction = button.getAttribute("data-action");

            if (this.entityActions[btnAction]) {
                Helper.reattachEventListener(button, 'click', e => {
                    this.entityActions[btnAction].doAction(e);
                });
            }
        });
        if(this.isDirty){

        }

        let selectAllCheckbox = this.container.find('[id^=selectAll]');
        
        if (selectAllCheckbox.length > 0) {
            Helper.reattachEventListener(selectAllCheckbox[0], 'click', this.toggleAllCheckboxes.bind(this));
        }

        // enable actions to menu above table
        // var tableMenu = this.container.find('.table-actions');
        var tableMenuButtons = this.container.find('.table-actions button, p a');

        Array.prototype.forEach.call(tableMenuButtons, (button, index) =>{
            var btnAction = button.getAttribute("data-action");
            
            if (btnAction && this.entityActions[btnAction]) {
                Helper.reattachEventListener(button, 'click', e => {
                    this.entityActions[btnAction].rowsAction(e);
                });

                // button.addEventListener("click", e => {
                //     this.entityActions[btnAction].rowsAction(e);
                // });
            }

            /* if(btnAction == "suspend") {
                Helper.reattachEventListener(button, 'click', this.suspendRowsAction.bind(this));          
            } else if(btnAction == "activate") {
                Helper.reattachEventListener(button, 'click', this.activateRowsAction.bind(this));          
            } else if(btnAction == "import") {
                Helper.reattachEventListener(button, 'click', this.importRowsAction.bind(this));          
            } else if(btnAction == "delete") {
                Helper.reattachEventListener(button, 'click', this.deleteRowsAction.bind(this));
            } else if (btnAction == "add") {
                Helper.reattachEventListener(button, 'click', this.addAction.bind(this));
            } else if (btnAction == "merge") {
                Helper.reattachEventListener(button, 'click', this.mergeRowsAction.bind(this));
            } else {
                return;
            } */
        });

        //if no records exist
        var buttonLinks = document.querySelectorAll("#dataTable .btn-link");
        Array.prototype.forEach.call(buttonLinks, (button, index) =>{
            var btnAction = button.getAttribute("data-action");

            if(btnAction == "import") {
                Helper.reattachEventListener(button, 'click', this.importRowsAction.bind(this));   
            }
        });

    }

    loadingSpinner() {
        const spinner = document.getElementById("loadingSpinner");
        if (spinner) {
            this.container[0].innerHTML = spinner.innerHTML;
        }
    }

    loadList() {
        var formElement = document.querySelector('[name="' + this.name + '"]');
        var formData = new FormData(formElement);

        let url = this.config.indexRoute;

        this.loadingSpinner();

        var _this = this;

        if (!url) {
            switch (this.action) {
                case "reassign":
                    url = '/weave/' + this.section + "/reassignList";
                    break;
                default:
                    url = '/weave' + formElement.attributes.action.value;
                    break;
            }
        }
      
        $.ajax(
            url,
            {
                data: formData,
                processData: false,
                contentType: false,
                method: "POST"
            }
        ).done(function(data) {
            _this.setListHtml(data);
        });
    }

    loading(message) {
        var modal = new Modal("notification");
        var event = new Event('notify');
        modal.setModalHeader(message);
        modal.open(event);
        this.loadingModal = modal;
        this.loadingEvent = event;
    }

    stopLoading() {
        if (this.loadingModal && this.loadingEvent) {
            this.loadingModal.close(this.loadingEvent);
            this.loadingModal = null;
            this.loadingEvent = null;
        }
    }

    initCarousels(arrows=true) {

        var recommendedSections = document.querySelectorAll('.recommendedSection');
        var isInitialised = false;
        var isDestroyed = false;

        var carouselBreakpoints = {
            6: {
                1024: {
                    slidesPerView: 6,
                    slidesPerGroup: 6,
                },
                920: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                769: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                650: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                },
                480: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            },
            8: {
                1024: {
                    slidesPerView: 8,
                    slidesPerGroup: 8,
                },
                920: {
                    slidesPerView: 5,
                    slidesPerGroup: 5,
                },
                800: {
                    slidesPerView: 4,
                    slidesPerGroup: 4,
                },
                600: {
                    slidesPerView: 3,
                    slidesPerGroup: 3
                },
                480: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                }
            }
        };

        recommendedSections.forEach(function(section, index) {

            section.id = `recommendedSection${index}`;

            var slider = section.querySelector('.swiper-container');
            var noSlides = parseInt(section.dataset.slides);
            var slidetoshowcount = parseInt(section.getAttribute('slidetoshowcount'));
            
            if(!slider.classList.contains("swiper-container-initialized") && window.innerWidth > 481){
                
                // get minimum 
                var breakpoints = carouselBreakpoints[slidetoshowcount];
                var slidesPerView = slidetoshowcount;
                for (const width in breakpoints) {
                    if(window.innerWidth > width){
                        continue;
                    }else{
                        slidesPerView = breakpoints[width]["slidesPerView"];
                        break;
                    }
                };

                var navigationArrows = arrows ? { nextEl: '.swiper-button-next',  prevEl: '.swiper-button-prev',
                } : false;

                window.swiper[index] = new Swiper(`#recommendedSection${index} .swiper-container`, {
                    // Disable preloading of all images
                    preloadImages: slidesPerView > noSlides,
                    checkInView: true,
                    // Enable lazy loading
                    lazy: true,
                    watchSlidesVisibility: true,
                    spaceBetween: 10,
                    loop:  noSlides > slidesPerView,
                    centerInsufficientSlides: true,
                    //centeredSlides: slidesPerView > noSlides,
                    navigation: navigationArrows,
                    breakpoints: carouselBreakpoints[slidetoshowcount],
                    on: {
                        beforeInit: function () {
                            section.querySelector(".sliderOverlay").style.display = "block";
                        },
                        init: function () {
                            section.querySelector(".sliderOverlay").style.display = "none";
                        },
                        beforeDestroy: function () {
                            section.querySelector(".sliderOverlay").style.display = "block";
                        },
                        destroy: function () {
                            section.querySelector(".sliderOverlay").style.display = "none";
                        },
                        lazyImageLoad: function (swiper, slideEl, imageEl) {
                            //set backup
                            if(!imageEl.dataset.backupSrc){
                                var imageSrc = imageEl.dataset.src;
                                imageEl.setAttribute("data-backup-src", imageSrc);
                            }

                        },
                        lazyImageReady: function (swiper, slideEl, imageEl) {
                            //use backup to recreate data-src
                            if(imageEl.src && !imageEl.dataset.src){
                                var backupSrc = imageEl.dataset.backupSrc;
                                imageEl.setAttribute("data-src", backupSrc);
                            }

                        },

                        afterInit: function (swiper) {
                            var navHack = false;
                            //Hack for some reason on libraries the next button is disabled.

                            if(swiper.navigation.nextEl && swiper.navigation.nextEl.classList.contains("swiper-button-disabled")){
                                swiper.navigation.nextEl.disabled = false;
                                swiper.navigation.nextEl.classList.remove('swiper-button-disabled');
                                swiper.navigation.nextEl.removeAttribute("aria-disabled"); 
                                navHack = true;                           
                            }

                            if(swiper.navigation.prevEl && swiper.navigation.prevEl.classList.contains("swiper-button-disabled")){
                                swiper.navigation.prevEl.disabled = false;
                                swiper.navigation.prevEl.classList.remove('swiper-button-disabled');
                                swiper.navigation.prevEl.removeAttribute("aria-disabled");  
                                navHack = true;                           
                            }                            
                            

                            if(navHack){
                                swiper.navigation.update();
                            }
                        }
                    },
                });
            } else if (slider.classList.contains("swiper-container-initialized") && window.innerWidth < 480){

                window.swiper[index].destroy(true, true);
                if(index === recommendedSections.length - 1){
                    window.swiper = [];
                }
            } else{
                section.querySelector(".sliderOverlay").style.display = "none";
                
                // lazyload images in mobile grid view
                var visibleSlides = section.querySelectorAll(".swiper-container .swiper-slide:not(:nth-of-type(n + 5))");
                visibleSlides.forEach(slide => {
                    var slideImage = slide.querySelector(".swiper-lazy");
                    slideImage.src = slideImage.dataset.src;
                });
            }
        });

    }


}

export { Index };